import { catchError, map, Observable, take, tap, throwError } from 'rxjs';

/**
 * Streams a PDF {@link Blob} into a new browser window and revokes the object URL after a delay.
 *
 * @param pdfBlob - The observable stream of the PDF {@link Blob}.
 * @returns An observable that completes when the PDF is opened in a new window.
 */
export function openPdfInNewWindow(
    pdfBlob: Observable<Blob>,
): Observable<void> {
    const popup = window.open('', '_blank');

    return pdfBlob.pipe(
        take(1),
        map((blob) => new Blob([blob], { type: 'application/pdf' })),
        map((pdfBlob) => URL.createObjectURL(pdfBlob)),
        tap((url) => {
            if (popup) {
                popup.location.href = url;
            }
            setTimeout(() => {
                URL.revokeObjectURL(url);
            }, 60_000);
        }),
        map(() => void 0),
        catchError((error) => {
            if (popup && !popup.closed) {
                popup.close();
            }

            return throwError(
                () =>
                    new Error(
                        'Failed to open PDF in new window with error: ' + error,
                    ),
            );
        }),
    );
}
